<template>
  <ul class="list_box">
    <li v-for="(item, index) in list" :key="item.id" @click="jump(item)">
      <div class="list_div vux-1px-b" v-if="item.type == 5 || item.type == 6">
        <img class="leftImg" :src="item.coverUrl" alt="" />
        <div class="right_box">
          <p class="right_title">{{ item.title }}</p>
          <div class="right_bottom">
            <!--<img  src="http://wechatfolder.oss-cn-beijing.aliyuncs.com/master/image/%E6%92%AD%E6%94%BE%E6%AC%A1%E6%95%B0@2x.png" alt="" >-->
            <span class="r_b_s1">{{ item.source }}</span>
            <span>{{ item.createTime }}</span>
          </div>
        </div>
      </div>
      <div class="list_div vux-1px-b" v-else>
        <img
          style="width: 2.93rem;"
          class="leftImg"
          :src="item.coverUrl"
          alt=""
        />
        <div class="right_box">
          <p class="right_title">{{ item.title }}</p>
          <div class="right_bottom">
            <div class="r_b_b">
              <img v-if="item.logo" :src="item.logo" alt="" />
              <span class="r_b_s1">{{ item.source }}</span>
            </div>

            <span>{{ item.readNum }} 位同行阅读</span>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: '',
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    detailObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    jump(item) {
      this.$sa.re_zone({
        event_type: '点击',
        zonename: this.detailObj.title, // 消费类型 直播，录播，资讯，病例，看课时长上报
        zoneid: this.detailObj.id, // 内容名字
        contentname: item.title, // 直播时间/发布时间 直播是直播时间，录播是发布时间，资讯、病例是发布时间
        contentid: item.id, // 内容id
        first_cate: '', //一级分类
        second_cate: '', // 2级分类
        first_cate_id: '', // 1级分类id
        second_cate_id: '', //2级分类id
        contentype: item.type
      });
      if (item.type == 3 || item.type == 2) {
        this.$router.push({
          name: 'headlineDetail',
          params: { id: item.id },
          query: { type: item.type }
        });
      } else if (item.type == 5 || item.type == 6) {
        let name = item.type == 5 ? 'liveDetail' : 'courseDetail';
        this.$router.push({ name: name, params: { id: item.id } });
      }
    }
  },
  computed: {},
  components: {},
  mounted() {},
  filters: {
    heighLight: function(v) {
      return v + '<span>123</span>';
    }
  }
};
</script>
<style lang="less" scoped>
.list_box {
  li:last-child {
    border: none;
  }
  .list_div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*border-bottom: 1px solid #EBEBEB;*/
    padding-bottom: 0.4rem;
    margin-top: 0.4rem;
    .leftImg {
      width: 3.306rem;
      height: 1.866rem;
      border-radius: 2px;
    }
    .right_box {
      width: 65%;
      margin-left: 0.267rem;
      .right_title {
        font-size: 0.3733rem;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
      }
      .list_imgs {
        display: flex;
        justify-content: flex-start;
        margin-top: 0.1rem;
        img {
          width: 3.306rem;
          height: 1.9733rem;
          margin-right: 0.3rem;
        }
      }
      .right_bottom {
        display: flex;
        align-items: center;
        position: relative;
        margin-top: 0.266rem;
        justify-content: space-between;
        img {
          width: 0.4rem;
          height: 0.4rem;

          margin-right: 0.16rem;
        }
        span {
          font-size: 0.32rem;
          color: #999;
        }
        .r_b_b {
          display: flex;
          align-items: center;
          width: 2.8rem;
        }
        .r_b_s1 {
          width: 2.8rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
        span:nth-of-type(2) {
          // position: absolute;
          // right: 0;
        }
      }
    }
  }
}
</style>
